module.exports = __webpack_public_path__ + "img/rg-bottom.d6b58c6a.png";